import { getSocket } from '@/services/socket/websocket.service'
import adminService from '../api/admin.service'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'

// Track registered listeners
const registeredEvents = new Set()
let callDataUpdateCallback = null

/**
 * Join the admin calls monitoring channel with authentication
 * @returns {Promise<Object>} Result of join attempt
 */
export const joinAdminCallsChannel = async () => {
    try {
        console.log('=====Joining admin calls channel')
        // Get the ID token
        const idToken = await firebase.auth().currentUser.getIdToken(true)
        console.log('=====ID Token:', idToken)
        const socket = getSocket()
        console.log('=====Socket:', socket)

        if (!socket) {
            console.error('Cannot join admin calls: Socket not available')
            return { success: false, message: 'Socket not available' }
        }

        // Emit the join event with the ID token
        socket.emit('join adminCalls', idToken)
        console.log('Attempting to join admin calls monitoring...')

        // Setup event listeners
        setupCallEventListeners()

        return { success: true, message: 'Join request sent' }
    } catch (error) {
        console.error('Failed to join admin calls:', error)
        return {
            success: false,
            message: error.message || 'Failed to join admin calls',
        }
    }
}

/**
 * Set up listeners for call-related events
 */
const setupCallEventListeners = () => {
    const socket = getSocket()
    if (!socket) return

    // Handle call started event
    if (!registeredEvents.has('call_started')) {
        console.log('Setting up call started event listener')
        socket.on('call_started', async (data) => {
            console.log('Call started event received:', data)
            await refreshCallData()
        })
        registeredEvents.add('call_started')
    }

    // Handle call ended event
    if (!registeredEvents.has('call_ended')) {
        console.log('Setting up call ended event listener')
        socket.on('call_ended', async (data) => {
            console.log('Call ended event received:', data)
            await refreshCallData()
        })
        registeredEvents.add('call_ended')
    }
}

/**
 * Refresh call data via the admin service
 */
const refreshCallData = async () => {
    try {
        const response = await adminService.getRecentCallSessions()

        if (response.success && callDataUpdateCallback) {
            callDataUpdateCallback(response.data)
        }
    } catch (error) {
        console.error('Error refreshing call data:', error)
    }
}

/**
 * Register a callback function to be called when call data is refreshed
 * @param {Function} callback - Function to be called with the updated data
 */
export const onCallDataUpdate = (callback) => {
    if (typeof callback === 'function') {
        callDataUpdateCallback = callback
    }
}

/**
 * Clean up all registered event listeners
 */
export const cleanupEventListeners = () => {
    const socket = getSocket()
    if (!socket) return

    registeredEvents.forEach((event) => {
        socket.off(event)
    })

    registeredEvents.clear()
    callDataUpdateCallback = null
    console.log('Cleaned up admin socket event listeners')
}

export default {
    joinAdminCallsChannel,
    onCallDataUpdate,
    cleanupEventListeners,
}
